import React from 'react';
import { AuthMemberCard } from '@tribeplatform/react-components/AuthMemberCard';
import { useSlateKitContext } from '../../hooks/index.js';
export const AuthMemberCardBlock = () => {
    const { context: { memberBannerPlaceholders }, } = useSlateKitContext();
    return React.createElement(AuthMemberCard, { placeholderBanners: memberBannerPlaceholders });
};
//# sourceMappingURL=Block.js.map